import ExhibitorView from './ExhibitorView';

export default ExhibitorView;
